// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-099d4842] .ui-modal-content {\n  width: 500px !important;\n}\n.v-stack[data-v-099d4842] {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
